import {useAuth} from "base/auth";

const ConcelloHiddenAuth = ({children}) => {
    const {ROLES, hasRole} = useAuth();

    return !hasRole(ROLES.CONCELLO) ? <>{children}</> : null;
};

export default ConcelloHiddenAuth;
